<template>
  <div class="fts-automation-badge">
    
    <template v-if="module && module.id">
      <fts-moji
        :emoji="module.emoji"
        :size="emojiSize"
        class="automation-badge__emoji"
        v-if="module.emoji"
      />
      <div class="automation-badge__label">
        {{ module.name }} <span v-if="isList">List</span> <span v-if="isGroup">Group</span>
      </div>
    </template>
    <div class="automation-badge__divider" v-if="divider">-</div>
    <template v-if="activity && activity.id">
      <fts-moji
        :emoji="activity.emoji"
        :size="emojiSize"
        class="automation-badge__emoji"
        v-if="activity.emoji"
      />
      <div class="automation-badge__label">
        {{ activity.name? activity.name : activity.id }}
      </div>
    </template>
    <template v-if="information && information.id">
      <div class="automation-badge__label">
        - {{ information.displayName }} Row
      </div>
    </template>
  </div>
</template>

<script>
import FTSMoji from "../../elements/FTSMoji";

export default {
  props: {
    moduleId: [String, Number],
    activityId: [String, Number],
    informationId: String,
    isList: Boolean,
    isGroup: Boolean,
    emojiSize: {
      type: Number,
      default: 12,
    },
  },
  components: {
    "fts-moji": FTSMoji,
  },
  data: () => ({
    module: null,
    information: null,
    activity: null,
  }),
  methods: {
    async getModule() {
      let vm = this;
      if (this.moduleId) {
        let data = await this.$store.dispatch("findVariable", {
          moduleId: this.moduleId,
        });
        vm.module = data;

        if (vm.module && vm.activityId) {
          let standard = vm.module.standards.find((x) => x.id == vm.activityId);
          if (standard) {
            vm.activity = standard;
          } else {
            vm.activity = vm.module.activities.find(
              (x) => x.id == vm.activityId
            );
          }
        }

        if (vm.module && vm.informationId) {
          let information = vm.module.information.find(
            (x) => x.id == vm.informationId
          );
          vm.information = information;
        }
      }
    },
  },
  computed: {
    divider() {
      return this.module && this.module.id && this.activity && this.activity.id;
    },
  },
  watch: {
    moduleId: async function (newValue, oldValue) {
      await this.getModule();
    },
    activityId: async function (newValue, oldValue) {
      await this.getModule();
    },
    informationId: async function (newValue, oldValue) {
      await this.getModule();
    },
  },
  async mounted() {
    await this.getModule();
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-automation-badge {
  min-width: 0;
  display: flex;
  align-items: center;
  .automation-badge__emoji {
    flex-shrink: 0;
    margin-right: 0.375rem;
  }
  .automation-badge__label {
    @include text-overflow-ellipsis;
  }
  .automation-badge__divider {
    flex-shrink: 0;
    padding: 0 0.375rem;
  }
}
</style>